// extracted by mini-css-extract-plugin
module.exports = {"select":"Filter_select__2xCaZ","input-text":"Filter_input-text__1aSCS"};